import React from "react";

import { Auth } from "../../../context/admin/Authentication";

import Screen from "../../home/content/Screen";

import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";
import Detail from "./Details";

import { CountryProvider } from "../../../context/country/countryContext/CountryContext";
import { DoSeeDataProvider } from "../../../context/doSeeData/DoSeeDataContext";
import { PositionProvider } from "../../../context/position/PositionContext";

export const Cinema = () => {
  return (
    <DoSeeDataProvider>
      <PositionProvider>
        <Auth
          children={
            <Screen
              component={<Overview />}
              title="Cinema"
            />
          }
        />
      </PositionProvider>
    </DoSeeDataProvider>
  );
};

export const AddCinema = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Add />}
              title="Add Cinema"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};

export const EditCinema = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Edit />}
              title="Edit Cinema"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};

export const ViewCinema = () => {
  return (
    <DoSeeDataProvider>
      <Auth
        children={
          <Screen
            component={<Detail />}
            title="Cinema Details"
          />
        }
      />
    </DoSeeDataProvider>
  );
};
